/**
 * Campaign Mode Script — Borås Tidning
 *
 * 1. On campaign collection pages: adds campaign-mode class and rewrites
 *    product links to include ?campaign=1.
 * 2. On product pages with ?campaign=1: adds campaign-mode class and
 *    dynamically loads campaign.css.
 * 3. Swaps logos using URL from window.campaignConfig (set in theme.liquid).
 */

(function () {
  'use strict';

  var config = window.campaignConfig || {};
  var PARAM_KEY = 'campaign';
  var PARAM_VALUE = '1';
  var BODY_CLASS = 'campaign-mode';

  function isCampaignCollectionPage() {
    var body = document.body;
    return (
      body.classList.contains('template-collection-campaign') ||
      body.classList.contains('template-collection-campaign-products')
    );
  }

  function hasCampaignParam() {
    var params = new URLSearchParams(window.location.search);
    return params.get(PARAM_KEY) === PARAM_VALUE;
  }

  function rewriteProductLinks() {
    document.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        if (!url.searchParams.has(PARAM_KEY)) {
          url.searchParams.set(PARAM_KEY, PARAM_VALUE);
          link.href = url.toString();
        }
      } catch (e) {}
    });
  }

  function observeNewLinks() {
    var observer = new MutationObserver(function (mutations) {
      var hasNew = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 &&
            ((node.tagName === 'A' && node.href && node.href.includes('/products/')) ||
              node.querySelector && node.querySelector('a[href*="/products/"]'))) {
            hasNew = true;
          }
        });
      });
      if (hasNew) rewriteProductLinks();
    });
    observer.observe(document.getElementById('MainContent') || document.body, {
      childList: true, subtree: true
    });
  }

  function swapLogo() {
    if (!config.logoUrl) return;
    var width = config.logoWidth || 160;

    // Header logos
    document.querySelectorAll('.header__heading-logo:not(.header__heading-logo--overlay)').forEach(function (logo) {
      var img = logo.cloneNode(true);
      img.classList.add('campaign-logo');
      img.src = config.logoUrl;
      img.srcset = config.logoUrl + ' 1x, ' + config.logoUrl + ' 2x';
      img.width = width;
      img.alt = 'Borås Tidning';
      logo.parentNode.insertBefore(img, logo.nextSibling);
    });

    // Footer logos
    document.querySelectorAll('.footer__logo-image').forEach(function (logo) {
      var img = logo.cloneNode(true);
      img.classList.add('campaign-logo');
      img.src = config.logoUrl;
      img.srcset = config.logoUrl + ' 1x, ' + config.logoUrl + ' 2x';
      img.width = width;
      img.alt = 'Borås Tidning';
      logo.parentNode.insertBefore(img, logo.nextSibling);
    });
  }

  function ensureCampaignCSS() {
    if (document.querySelector('link[href*="campaign.css"]')) return;
    var ref = document.querySelector('link[href*="custom.css"]');
    if (ref) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = ref.href.replace('custom.css', 'campaign.css');
      document.head.appendChild(link);
    }
  }

  function injectCampaignFooter() {
    var footer = document.querySelector('.footer');
    if (!footer) return;

    // Grab the original DP logo src before it gets hidden
    var origLogo = document.querySelector('.header__heading-logo:not(.campaign-logo):not(.header__heading-logo--overlay)');
    var origLogoSrc = origLogo ? origLogo.src : '';

    var el = document.createElement('div');
    el.className = 'campaign-footer';
    el.innerHTML =
      '<div class="campaign-footer__logos">' +
        (config.logoUrl ? '<a href="/"><img src="' + config.logoUrl + '" alt="Borås Tidning"></a>' : '') +
        '<span>×</span>' +
        (origLogoSrc ? '<a href="/"><img src="' + origLogoSrc + '" alt="Designed Posters" class="campaign-footer__dp-logo"></a>' : '<a href="/">Designed Posters</a>') +
      '</div>' +
      '<div class="campaign-footer__links">' +
        '<a href="/policies/privacy-policy">Integritetspolicy</a>' +
        '<a href="/pages/contact">Kontakt</a>' +
      '</div>';

    footer.appendChild(el);
  }

  function init() {
    var isCollection = isCampaignCollectionPage();
    var hasParam = hasCampaignParam();
    var alreadyActive = document.body.classList.contains(BODY_CLASS);

    if (!isCollection && !hasParam && !alreadyActive) return;

    document.body.classList.add(BODY_CLASS);
    swapLogo();
    injectCampaignFooter();

    if (isCollection || alreadyActive) {
      rewriteProductLinks();
      observeNewLinks();
    }

    if (hasParam) {
      ensureCampaignCSS();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
